import * as Icons from "@heroicons/vue/24/outline";
import { FunctionalComponent, HTMLAttributes, VNodeProps } from "vue";

type IconComponent = FunctionalComponent<HTMLAttributes & VNodeProps>;

export const ICONS: Record<string, IconComponent> = Object.entries(
  Icons
).reduce((result, [name, component]) => {
  return { ...result, [name]: component };
}, {});

export const availableIcons = Object.keys(ICONS);

export type IconName = (typeof availableIcons)[number];

export const getIconByName = (name: IconName) => ICONS[name];
